export function numRange(from: number, to: number): number[] {
    return Array.from(Array(Math.abs(to - from + (to < 0 ? -1 : 1))).keys()).map((n) => from + (to < 0 ? -n : n))
}
